import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { REDIRECT_ON_AUTH_KEY } from 'JS/config/sessionStorageKeys';

import { ROUTE_CODES } from '../../config/routes';
import { getSparkolToken } from '../../shared/helpers/TokenHelper';

import LoadingSpinner from './LoadingSpinner';

const AuthenticatedComponent = ({ component: Component, currentUser, isAuthenticating, location, ...rest }) => {
  const authToken = getSparkolToken();

  if (!authToken) {
    window.sessionStorage.setItem(REDIRECT_ON_AUTH_KEY, location.pathname);
  }

  return (
    <Route
      {...rest}
      render={props =>
        authToken ? (
          <>
            {currentUser.authenticated !== true && isAuthenticating === true ? (
              <LoadingSpinner message={resx('spinner-authenticating')} />
            ) : (
              <Component {...props} />
            )}
          </>
        ) : (
          <Redirect to={ROUTE_CODES.LOGIN} />
        )
      }
    />
  );
};

export default connect(state => ({
  currentUser: state.auth && state.auth.currentUser,
  isAuthenticating: state.auth && state.auth.isAuthenticating
}))(AuthenticatedComponent);
